class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.deadline);
    if (Number.isNaN(this.deadline)) {
      this.hidden = true;
      return;
    }

    this.parts = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };

    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = this.deadline - Date.now();

    if (remaining <= 0) {
      clearInterval(this.timer);
      this.hidden = true;
      return;
    }

    const seconds = Math.floor(remaining / 1000);
    this.render('days', Math.floor(seconds / 86400));
    this.render('hours', Math.floor(seconds / 3600) % 24);
    this.render('minutes', Math.floor(seconds / 60) % 60);
    this.render('seconds', seconds % 60);
  }

  render(part, value) {
    const node = this.parts[part];
    if (node) node.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
